import { Message } from "./message-list";
import UserMessage from "./user-message";
import AssistantMessage from "./assistant-message";
import { cn } from "@/lib/utils";

const MessageItem = ({
  message,
  messageIndex,
  isLastMessage,
  previousMessage,
}: {
  message: Message;
  messageIndex: number;
  isLastMessage: boolean;
  previousMessage: Message;
}) => {
  return (
    <li
      className={cn(
        "flex justify-start",
        message.messageType === "USER" && "justify-end"
      )}
    >
      {message.messageType === "USER" ? (
        <UserMessage message={message} />
      ) : (
        <AssistantMessage
          message={message}
          messageIndex={messageIndex}
          previousMessage={previousMessage}
          isLastMessage={isLastMessage}
        />
      )}
    </li>
  );
};

export default MessageItem;
